<template>
  <div class="row">
    <div class="col-sm-3"></div>
    <div class="col-sm-6 text-center">
      <h5>It looks like the page you're looking for doesn't exist.</h5>
    </div>
    <div class="col-sm-3"></div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>